export const CONTAINERS = {
  MEDIA: 'media',
  READER_REQUESTS: 'reader-requests',
  ANALYTICS_REPORTS: 'analytics-reports',
  TOBACCO_PRODUCTS: 'tobacco-products'
};
